import { Formik, Form, Field, ErrorMessage } from 'formik';
import axios from "axios";
import "../../../src/assets/css/App.css"
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { AUTH_URL } from '../../../src/configs/AppConfig';
import { MdArrowBackIos } from "react-icons/md";
import { Link } from "react-router-dom";


export default function ResetPass() {
    
    const { token } = useParams();
    const navigate = useNavigate()

    function handleRedirct() {
      navigate('/auth/sign-in');
    }
    const success = () => {
        message.success('Your Password reset is done');
      };
      
  
    return (
        <> 
      <div className="resetPass-img">
      </div>
    <div className="flex items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start login-inputs">
      {/* Sign in section */}
      <div className="w-full max-w-full flex-col items-center lg:pl-0 ">
       <Link to="/auth/sign-in" className="mt-1 dark:text-white BackLog"> 
       <MdArrowBackIos className=" arrowBac" /> <span>Back to login</span> </Link> 
        <h4 className="login-text">
          Set password
        </h4>
        <p className="details-text">
          Please enter your new password to reset your password
        </p>
        <div>

     <Formik
       initialValues={{ password: ''}}
       validate={values => {
         const errors = {};
         if (!values.password) {
            errors.password = 'Password is required';
        } 
        else if (!values.confirmPassword) {
            errors.confirmPassword = 'Confirm Password required';
          }
          else if (values.password !== values.confirmPassword) {
            errors.confirmPassword = "Password doesn't not match";
          }
         return errors;
       }}
       onSubmit={(values ,{setSubmitting}) => {
        
       axios.post(`${AUTH_URL}reset-password/${token}`, {
          password: values.password.trim(),
        })
        .then(function (response) {
          success()
          handleRedirct()        
        })
        .catch(function (error) {
        //   errorM()
          console.log(error);
          setSubmitting(false);
        });
         }
      }
     >
       {({ isSubmitting }) => (
         <Form>
           <Field type="password" placeholder="Create Password" name="password" id="password" className={`flex h-12 w-full items-center justify-center border bg-white/0 p-3 outline-none inputs-css`}/>
           <ErrorMessage name="password" component="div" id="erroMassage" />
           <Field type="password" placeholder="Re Enter Password" name="confirmPassword" id="confirmPassword" className={`flex h-12 w-full items-center justify-center border bg-white/0 p-3 outline-none inputs-css`}/>
           <ErrorMessage name="confirmPassword" component="div" id="erroMassage" />
            <button type="submit" disabled={isSubmitting} className="linear w-full py-[12px] text-base transition duration-200 hover:bg-brand-600 active:bg-brand-700 login-btn">
           Set Password
           </button>
         </Form>
       )}
     </Formik>
   </div>
      </div>
    </div>
    </>
  );
};
